module.exports = __webpack_public_path__ + "51983709c20f1efa062cbd17978bd1b4.png";